import { createContext } from 'react';

import type { ModalFuncWithPromise } from 'antd/lib/modal/useModal';

interface AntModalContextProps {
    confirm?: ModalFuncWithPromise;
    warning?: ModalFuncWithPromise;
    success?: ModalFuncWithPromise;
    error?: ModalFuncWithPromise;
    info?: ModalFuncWithPromise;
}

export const AntModalContext = createContext<AntModalContextProps>({});
